import NotFound from './pages/notFound';

import Drivers from './pages/drivers/drivers';
import DriverDetails from './pages/drivers/driverDetails';
import NewDriver from './pages/drivers/newDriver';

import Containers from './pages/containers/containers';
import ContainerDetails from './pages/containers/containerDetails';
import NewContainer from './pages/containers/newContainer';

import NewClient from './pages/clients/newClient';

import Expenses from './pages/expenses/expenses';
import NewExpense from './pages/expenses/newExpense';
import GetMoney from './pages/expenses/getMoney';

export * from './pages/delivered-loose-orders/delivered-loose-orders';
import OrderDetails from './pages/orders/orderDetails';
import NewOrder from './pages/orders/newOrder';

import Tasks from './pages/tasks/tasks';
import TaskDetails from './pages/tasks/taskDetails';
import ContainerSelection from './pages/tasks/containerSelection';
import TaskClosingScreen from './pages/tasks/taskClosingScreen';
import Sign from './pages/tasks/sign';
import SavedSign from './pages/tasks/savedSign';

import Settings from './pages/settings';
import FastActions from './pages/fastActions';

import Stats from './pages/stats/stats';

export * from './pages/clients/clients';
export * from './pages/clients/client-details';
export * from './pages/drivers/driver-card';
export * from './pages/finances/finances';
export * from './pages/orders/orders';
export * from './pages/tasks/new-task-details';
export * from './pages/tasks/new-task-closing';
export {
	NotFound,
	Drivers,
	DriverDetails,
	NewDriver,
	Containers,
	ContainerDetails,
	NewClient,
	NewContainer,
	Expenses,
	NewExpense,
	GetMoney,
	OrderDetails,
	NewOrder,
	Tasks,
	TaskDetails,
	ContainerSelection,
	TaskClosingScreen,
	Sign,
	SavedSign,
	Settings,
	Stats,
	FastActions,
};
